import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {WidgetTemperature} from '../../../components/widget/widget_temperature.tsx';
import {Widget} from '../../../components/widget/widget.tsx';

export function TemperatureWidget() {
    // TODO: Make interactive
    return (
        <Widget>
            <FlexRow>
                <FlexColumn>
                    <FlexRow>
                        <Icon iconClassName="fa-light fa-temperature-half" outline={false} />
                        <FlexColumn>
                            <strong style={{marginLeft: '1rem'}}>Het is lichtbewolkt</strong>
                            <span style={{marginLeft: '1rem'}}>Max: 26º | Min: 11º</span>
                        </FlexColumn>
                    </FlexRow>
                </FlexColumn>

                <FlexColumn alignment={Alignment.End}>
                    <WidgetTemperature value={24} />
                </FlexColumn>
            </FlexRow>
        </Widget>
    );
}
